import React from 'react'
import styles from './index.module.sass'

interface Props {
  power?: number
  center: boolean,
  show: boolean
}

const POWER_MULTIPLY = 1000

export const Engine: React.FC<Props> = ({ power = 1, show, center }) => {
  return (
    <div className={`${styles.root} ${show ? styles.active : ''} ${center ? styles.center : ''}`}>
      <div className={styles.wrapper }>
        <div className={styles.image}>
          <img src='./imgs/engine.png' alt='someshie'/>
        </div>
        <div className={styles.text}>
          <div className={styles.text_header}>
            RPM {power * POWER_MULTIPLY}
          </div>
          <div className={styles.text_footer}>
            ENGINE POWER
          </div>
        </div>
      </div>
    </div>
  )
}
